module.exports = __webpack_public_path__ + "img/1505324458.29d0df2e.jpg";